import { abortable as abortableBase } from "@enfusion-ui/utils";
import queryString from "query-string";
export default (restServer) => {
    const abortable = (c) => abortableBase(restServer, c);
    return {
        GET_BOOK: (bookId) => restServer(`/internal/api/fund/v1/books/${bookId}`),
        GET_BOOKS: () => restServer("/internal/api/fund/v1/books/all"),
        GET_BOOKS_LEVELS: () => restServer("/internal/api/fund/v1/books/hierarchies"),
        GET_BOOKS_HIERARCHY: (levels, showInactive, searchText) => restServer(queryString.stringifyUrl({
            url: "/internal/api/fund/v1/books/hierarchy",
            query: {
                levels,
                showInactive,
                searchText,
            },
        })),
        GET_STRATEGY_BOOK_PATH: () => "/internal/api/fund/v1/books/strategy",
        GET_FUND_HIERARCHY: () => restServer("/internal/api/fund/v1/accounts/hierarchy"),
        GET_ACCOUNT_DETAILS: (accountId) => restServer(`/internal/api/fund/v1/accounts/${accountId}`),
        GET_SHARE_CLASSES: abortable(() => "/internal/api/fund/v1/shareclasses"),
        GET_SHARE_CLASSES_PATH: () => "/internal/api/fund/v1/shareclasses",
        GET_LEDGER_HIERARCHY: () => restServer("/internal/api/gl/v1/ledgers/hierarchy"),
    };
};
